import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Login from './components/login/Login';
import Register from './components/login/Register';
import BorrarDatos from './components/borrarDatos/BorrarDatos'
//import Layout from './components/layout/Layout';
import Inicio from './components/inicio/Inicio';
import PageNotFound from './components/pageNotFound/PageNotFound';

import MisReportes from './components/layout/misReportes/MisReportes';
import MiUni from './components/layout/crearReporte/miUni/MiUni';
import Delito from './components/layout/crearReporte/delito/Delito';
import MiEscuela from './components/layout/crearReporte/miEscuela/MiEscuela';
import { useUser } from './userContext';
import PopupMensaje from './iu/popupMensaje/PopupMensaje';
import './App.css';

import iconoInicio from './assets/iconos_amarillos/inicio_blanco.png';
import whattsapp from './assets/whatsapp.webp';
import socket from './services/socket';


function App() {
  const version = '2.0.0';
  const { isLogged } = useUser();

  useEffect(() => {
    socket.on('version', (versionRemota) => {
      console.log("version local: " + version);
      console.log("version remota: " + versionRemota);
      if (versionRemota !== version) {
        const titulo = `Actualizando a la versión ${versionRemota}, la página se recargará en 10s`;
        setPopupMensaje(titulo);
        setTimeout(() => {
          window.location.reload();
        }, 10000);
      }
    });
    return () => {
      socket.off('version');
    };
  }, []);

  const [popupMensaje, setPopupMensaje] = useState('');
  const [popupKey, setPopupKey] = useState(0);

  const handlePopupClose = () => {
    setPopupMensaje('');
    setPopupKey((prevKey) => prevKey + 1);
  };

  return (
    <>
      <Routes>
        <Route path="/inicio" element={<Inicio />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={isLogged ? <Navigate to="/Inicio" /> : <Navigate to="/Inicio" />}
        />
        <Route path="/register" element={<Register />} />
        <Route path="/eliminar-mis-datos" element={<BorrarDatos />} />
        <Route path="/crear-reporte-mi-escuela" element={<MiEscuela />} />
        <Route path="/crear-reporte-mi-uni" element={<MiUni />} />
        <Route path="/crear-reporte-delito" element={<Delito />} />
        <Route path="/mis-reportes" element={<MisReportes />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {popupMensaje && (
        <PopupMensaje
          key={popupKey}
          mensaje={popupMensaje}
          onClose={handlePopupClose}
        />
      )}
      <button className="btn-inicio" onClick={() => window.location.href = '#/inicio'}>
        <img src={iconoInicio} alt="Inicio" />
      </button>

      <a
        className='whatsapp-btn'
        href="https://wa.me/524431135000"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className='whatsapp-btn-img' alt='whatsapp icono' src={whattsapp} />
      </a>
      <div className="version">
        v {version}
      </div>
    </>
  );
}

export default App;
